Shopify.SearchByAllTypes = (function() {
  var config = {
    sectionId: 'main-search',
    onComplete: null
  };

  return {
    renderResultTable: function(params) {
      var params = params || {};
      $.extend(config, params);

      this.section = document.getElementById(config.sectionId);
      if(!this.section) return;

      this.url = this.section.getAttribute('data-url');
      this.id = this.section.getAttribute('data-id');

      fetch(this.url)
        .then(response => response.text())
        .then(responseText => {
          const html = responseText;
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const resultElements = parsedHTML
            .querySelector(`div[id="${config.sectionId}"]`)
            ?.querySelector('template')
            .content
            .firstElementChild
            .cloneNode(true);

          // Insert the new HTML if it exists:
          if (resultElements && resultElements.innerHTML.trim().length) {
            this.section.innerHTML = resultElements.innerHTML;

            // Optional "collection product" logic
            const collectionProduct = document.querySelector('.collection');
            const products = collectionProduct ? collectionProduct.querySelectorAll('.product') : [];
            if (collectionProduct) {
              if (products.length > 0) {
                collectionProduct.classList.add('productShowMore');
              } else {
                collectionProduct.classList.remove('productShowMore');
              }
            }
          } else {
            // If no content returned, remove the section
            this.section.remove();
          }

          // 1) Try to find the load-more anchor
          const loadMoreArticleBtn = document.getElementById('article-page-load-btn');

          // 2) If it's not there, stop here to avoid "null.dataset" error
          if (!loadMoreArticleBtn) {
            return;
          }

          // 3) Otherwise, read from .dataset safely
          const articlesPerLoad = parseInt(loadMoreArticleBtn.dataset.itemsPerPage);
          const totalArticles = parseInt(loadMoreArticleBtn.dataset.total);
          const totalPages = Math.ceil(totalArticles / articlesPerLoad);
          let currentPageNum = 1;

          // If fewer articles than the "per-load" count, hide the button
          if (totalArticles <= articlesPerLoad) {
            loadMoreArticleBtn.style.display = 'none';
          }
          // If there's only 1 page, also disable
          if (totalPages <= 1) {
            loadMoreArticleBtn.classList.add('disabled');
          }

          // Select all elements that represent articles or pages
          const articleAndPageElements = [
            ...document.querySelectorAll('[data-listed-article-or-page]')
          ];

          // Show only the first "articlesPerLoad" elements
          articleAndPageElements.forEach((element, index) => {
            if (index < articlesPerLoad) {
              element.classList.add('visible');
            } else {
              element.classList.remove('visible');
            }
          });

          // Listen for clicks on the "Load More" anchor
          loadMoreArticleBtn.addEventListener('click', () => {
            if (currentPageNum === totalPages) return;

            currentPageNum++;
            loadMoreArticleBtn.classList.add('is-loading');

            // Simulate a little loading delay
            const randomTime = Math.random() * 500 + 500;
            setTimeout(() => {
              articleAndPageElements.forEach((element, index) => {
                if (index < articlesPerLoad * currentPageNum) {
                  element.classList.add('visible');
                } else {
                  element.classList.remove('visible');
                }
              });

              // If we reached the last page, hide the button
              if (currentPageNum === totalPages) {
                loadMoreArticleBtn.style.display = 'none';
              }
              loadMoreArticleBtn.classList.remove('is-loading');
            }, randomTime);
          });
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
})();
